import { BellOff } from 'react-feather'

import Event, { EventProps } from './Event'
import { getEventDate } from './utils'

type EventsProps = {
  events: Omit<EventProps, 'onNotificationClick'>[]
  userId: string
  onNotificationClick: (eventId: string) => void
  emptyLabel?: string
}

export default function Events({ events, userId, onNotificationClick, emptyLabel = 'No notifications' }: EventsProps) {
  if (events.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center gap-3 px-6 py-12 text-center">
        <div className="flex h-12 w-12 items-center justify-center rounded-full bg-gray-100">
          <BellOff size={22} className="text-gray-400" aria-hidden="true" />
        </div>
        <p className="text-sm text-gray-500">{emptyLabel}</p>
      </div>
    )
  }

  // Most recent first — copy before sorting to avoid mutating the prop array.
  const sortedEvents = [...events].sort((a, b) => getEventDate(b.createdAt).getTime() - getEventDate(a.createdAt).getTime())

  return (
    <ul role="list" className="max-h-[24rem] divide-y divide-gray-100 overflow-y-auto px-3">
      {sortedEvents.map((event) => (
        <Event
          key={event.id}
          id={event.id}
          createdAt={event.createdAt}
          recipients={event.recipients}
          type={event.type}
          userId={userId}
          onNotificationClick={onNotificationClick}
        />
      ))}
    </ul>
  )
}
